export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000";

// Helper function to get the full API URL for an endpoint
export const getApiUrl = (endpoint) => {
  if (!endpoint) return API_BASE_URL;
  const path = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${path}`;
};

export function getAuthHeaders(extraHeaders = {}) {
  const headers = { ...extraHeaders };
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token");
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }
  return headers;
}

// Utility function for making authenticated API requests
export const apiRequest = async (url, options = {}) => {
  const fullUrl =
    url.startsWith("http://") || url.startsWith("https://")
      ? url
      : getApiUrl(url);

  const defaultOptions = {
    credentials: "include",
    headers: getAuthHeaders({
      "Content-Type": "application/json",
      ...options.headers,
    }),
  };

  return fetch(fullUrl, { ...defaultOptions, ...options });
};
